import gql from 'graphql-tag';

export const MODIFY_PICK_LIST_ITEM = gql`
	mutation modifyPickListItemMutation($input: ModifyPickListItemInput!) {
		modifyPickListItem(input: $input) {
			picklistitem {
				id
				product {
					id
					name
				}
				quantityProductSizeUnit
				quantity
				productSize
				productSizeUnit
				productMeasurementUnit
				planogramItemExpiryDatesAtPick
			}
		}
	}
`;

export { GET_PICKLIST_ITEMS_BY_PICKLIST_IDS } from './GET_PICKLIST_ITEMS_BY_PICKLIST_IDS';

export const PICK_LIST_ITEM_TOGGLE_IS_PICKED = gql`
	mutation toggleIsPicked ($id: ID!, $type: Int, $isPicked: Boolean) {
		toggleIsPicked (id: $id, type: $type, isPicked: $isPicked) {
			id
			isPicked
			extraQuantityIsPicked
			quantity
			extraQuantity
			tubWeightExcludedQuantity
			planogramItemExpiryDatesAtPick
		}
	}
`;

export const PICK_LIST_ITEM_SET_IS_PICKED_BULK = gql`
	mutation setIsPickedBulk ($serviceRunId: ID!, $machineId: ID, $productId: ID!, $pickListItemIds: [ID!], $isPicked: Boolean, $type: Int) {
		setIsPickedBulk (serviceRunId: $serviceRunId, machineId: $machineId, productId: $productId, pickListItemIds: $pickListItemIds, isPicked: $isPicked, type: $type) {
			id
			isPicked
			extraQuantityIsPicked
			quantity
			extraQuantity
			tubWeightExcludedQuantity
			planogramItemExpiryDatesAtPick
		}
	}
`;

export const MODIFY_PICKLIST_ITEMS_QUANTITY = gql`
	mutation modifyPicklistItemsQuantity ($ids: [ID!]!, $quantity: Int!, $includePickedQuantity: Boolean) {
		modifyPicklistItemsQuantity (ids: $ids, quantity: $quantity, includePickedQuantity: $includePickedQuantity) {
			id
			quantity
			extraQuantity
			isPicked
			extraQuantityIsPicked
			tubWeightExcludedQuantity
			planogramItemExpiryDatesAtPick
		}
	}
`;

export const MODIFY_PICKLIST_ITEMS_EXTRA_QUANTITY = gql`
	mutation modifyPicklistItemsExtraQuantity ($ids: [ID!]!, $extraQuantity: Int!) {
		modifyPicklistItemsExtraQuantity (ids: $ids, extraQuantity: $extraQuantity) {
			id
			extraQuantity
			tubWeightExcludedQuantity
		}
	}
`;

export const MODIFY_ALL_PICKLIST_ITEMS_QUANTITY_TO_ZERO = gql`
	mutation modifyAllPicklistItemsQuantityToZero ($id: ID!, $unpicked: Boolean) {
		modifyAllPicklistItemsQuantityToZero (id: $id, unpicked: $unpicked) {
			id
			quantity
			extraQuantity
			tubWeightExcludedQuantity
		}
	}
`;

export const SET_PICKLIST_ITEMS_TUB_WEIGHT_EXCLUDED_QUANTITY = gql`
	mutation setPickListItemsTubWeightExcludedQuantity ($ids: [ID!]!, $excludedQuantity: Int!) {
		setPickListItemsTubWeightExcludedQuantity (ids: $ids, excludedQuantity: $excludedQuantity) {
			id
			tubWeightExcludedQuantity
		}
	}
`;

export const GET_SUGGESTED_EXPIRY_DATES_FOR_PICK_LIST_ITEM = gql`
	query getSuggestedExpiryDatesForPickListItem ($pickListItemId: ID!) {
		getSuggestedExpiryDatesForPickListItem (pickListItemId: $pickListItemId)
	}
`;

export const GET_SUGGESTED_EXPIRY_DATES_FOR_PICK_LIST_ITEMS = gql`
	query getSuggestedExpiryDatesForPickListItems ($pickListItemIds: [ID!]) {
		getSuggestedExpiryDatesForPickListItems (pickListItemIds: $pickListItemIds)
	}
`;
